
$(document).ready(function () {

    $('.panel--text-gallery-3d .carousel').each((idx, e) => {
        carousel(e);
    });

    $('.panel--text-gallery-3d a.card__title').each((idx, e) => {
        $(e).on('click', event => {
            let target = (event.currentTarget.getAttribute('href'));
            let item = $(".panel--accordion a.card-link[href$='" + target + "']");

            if (item.length > 0) {
                event.preventDefault();
                if (item.hasClass('collapsed'))
                    item.click(); // Then Open 
                $('html, body').stop().animate({
        
                    scrollTop: $(".panel--accordion").offset().top
                }, 1000, function () {
                    // Animation complete.

                });
            }

        });
    });

});


function carousel(root) {
    var figure = $(root).find('figure');
    var nav = $(root).find('nav');
    var images = figure.children();
    const n = images.length;
    const gap = root.dataset.gap || 0;
    const bfc = 'bfc' in root.dataset;

    const theta = 2 * Math.PI / n;
    var currImage = 0;

    var animation;

    setupCarousel(n, parseFloat(getComputedStyle(images[0]).width));
    window.addEventListener('resize', () => {
        setupCarousel(n, parseFloat(getComputedStyle(images[0]).width))
    });

    setupNavigation();

    var interval_id;
    $(window).focus(function () {
        startAnimation();
    });

    $(window).blur(function () {
        stopAnimation();
    });

    startAnimation();

    function setupCarousel(n, s) {
        var apothem = s / (2 * Math.tan(Math.PI / n));

        figure[0].style.transformOrigin = `50% 50% ${- apothem}px`;

        for (var i = 0; i < n; i++)
            images[i].style.padding = `${gap}px`;
        for (i = 1; i < n; i++) {
            images[i].style.transformOrigin = `50% 50% ${- apothem}px`;
            images[i].style.transform = `rotateY(${i * theta}rad)`;
        }
        if (bfc)
            for (i = 0; i < n; i++)
                images[i].style.backfaceVisibility = 'hidden';

        rotateCarousel(currImage);
    }

    function setupNavigation() {
        $('.nav.next.btn').click(e => {
            stopAnimation();
            currImage++;
            rotateCarousel(currImage);
            setTimeout(startAnimation, 6000);
        });
        $('.nav.prev.btn').click(e => {
            stopAnimation();
            currImage--;
            rotateCarousel(currImage);
            setTimeout(startAnimation, 6000);
        });

        rotateCarousel(currImage);
    }

    function rotateCarousel(imageIndex) {
        figure[0].style.transform = `rotateY(${imageIndex * -theta}rad)`;
    }

    function startAnimation() {
        stopAnimation();
        animation = setInterval(function () {
            currImage = currImage + 1;
            rotateCarousel(currImage);
        }, 6000);
    }

    function stopAnimation() {
        clearInterval(animation);
    }

}

